// After a deploy, a tab that is still running the previous build asks for
// chunk files that no longer exist. Vite reports that as `vite:preloadError`;
// reloading the page gets the current build. The cooldown keeps a build that
// is genuinely unreachable from reloading forever.

const RELOAD_STORAGE_KEY = 'stale-build-reloaded-at';
const RELOAD_COOLDOWN_MS = 60_000;

let reloading = false;

const readLastReload = () => {
  try {
    return Number(sessionStorage.getItem(RELOAD_STORAGE_KEY)) || 0;
  } catch {
    return 0;
  }
};

const writeLastReload = (timestamp: number) => {
  try {
    sessionStorage.setItem(RELOAD_STORAGE_KEY, String(timestamp));
  } catch {
    return;
  }
};

/** True while a reload is in flight, so the error boundary can stay quiet. */
export const isReloadingStaleBuild = () => reloading;

/** Reloads once per cooldown window. Returns whether a reload was started. */
export const reloadOnStaleBuild = (
  reload: () => void = () => window.location.reload(),
) => {
  if (reloading) return true;

  const now = Date.now();
  if (now - readLastReload() < RELOAD_COOLDOWN_MS) return false;

  reloading = true;
  writeLastReload(now);
  reload();
  return true;
};

export const listenForStaleBuild = (reload?: () => void) => {
  window.addEventListener('vite:preloadError', () => {
    reloadOnStaleBuild(reload);
  });
};
